export function removeTralingSlash(urlLike=""){return urlLike.replace(/\/*$/,"")}export default removeTralingSlash;